import { create } from 'zustand';
import { apiService } from '@/services/api';
import type { Club } from '@/types';

interface ClubState {
  clubs: Club[];
  isLoading: boolean;
  error: string | null;
  fromCache: boolean;
  searchQuery: string;
  currentTab: string;
  fetchClubs: (forceRefresh?: boolean) => Promise<void>;
  setSearchQuery: (query: string) => void;
  setTab: (tab: string) => void;
  getFilteredClubs: () => Club[];
}

export const useClubStore = create<ClubState>((set, get) => ({
  clubs: [],
  isLoading: false,
  error: null,
  fromCache: false,
  searchQuery: '',
  currentTab: 'all',

  fetchClubs: async (forceRefresh = false) => {
    set({ isLoading: true, error: null });
    try {
      const result = await apiService.getClubs(forceRefresh);
      set({ clubs: result.data, fromCache: result.fromCache, isLoading: false });
    } catch (error) {
      set({ error: error instanceof Error ? error.message : 'Erreur de chargement', isLoading: false });
    }
  },

  setSearchQuery: (query: string) => set({ searchQuery: query }),
  setTab: (tab: string) => set({ currentTab: tab }),

  getFilteredClubs: () => {
    const { clubs, searchQuery } = get();
    if (!searchQuery.trim()) return clubs;
    const q = searchQuery.trim().toLowerCase();
    return clubs.filter((c) => c.nom && c.nom.toLowerCase().includes(q));
  },
}));
